module.exports = __webpack_public_path__ + "static/Donghwan-a5b7314bd2254962fc42bbea85d449b7.svg";